/// <amd-module name="VSS/Legacy/Components/Legacy/Legacy" />
import React = require("react");

import { ILegacyComponentProperties, ILegacyPlatformService } from "VSS/Legacy/Types";
import { Components, VssComponent, WrappedComponent } from "VSS/Platform/Layout";

/**
 * WrappedComponent is used to create and manage an underlying component.
 * The underlying component is defined by the componentType given to the wrapper
 * through the properties and is resovled either synchoronously or asynchronously
 * via Component registrations.
 */
export class LegacyComponent extends VssComponent<ILegacyComponentProperties, {}> {
    public render(): JSX.Element | null {
        const wrappedComponentProps = {
            ...this.props,
            modules: undefined,
            dependentContributionIds: undefined,
            onDependenciesResolved: this.onDependenciesResolved
        };

        if (this.props.componentType) {
            wrappedComponentProps.wrappedType = this.props.componentType;
        }

        return React.createElement(WrappedComponent, wrappedComponentProps, this.props.children);
    }

    private onDependenciesResolved = (): Promise<void> => {
        const legacyPlatformService = this.context.pageContext.getService<ILegacyPlatformService>("ILegacyPlatformService");
        return legacyPlatformService.loadModules(this.props.modules, this.props.dependentContributionIds);
    };
}

Components.add("legacy", LegacyComponent);
